// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Z71W","select":"Header_select__2K-73","clinic":"Header_clinic__3YhyK"};